module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10209.4bc94fc1.jpg";